import {getAuthToken} from "#build/imports";
import {viewport, initData} from "@telegram-apps/sdk";

export default function () {
    const authRole = useState<string | null>('authRole', () => null)
    const authLoading = useState<boolean>('authLoading', () => true)
    const authAbilities = useState<string[] | null>('authAbilities', () => null)

    authRole.value = null
    authAbilities.value = null

    authLoading.value = true

    viewport.expand.ifAvailable()

    initData.restore()

    const {login} = useSanctumAuth()

    login({
        telegramHash: initData.raw()
    }).then(() => {
        const userToken = useSanctumUser<ApiToken>()

        if(userToken.value != null) {
            const token = userToken.value

            authRole.value = token?.role
            authAbilities.value = token?.abilities

            const echo = useEcho()

            echo.leaveAllChannels()

            if (token.role === 'admin') {
                initAdminSubscribe()
            } else if (token.role === 'user') {
                initUserSubscribe()
            }

            authLoading.value = false
        }
    }).catch(() => {
        setTimeout(getAuthToken, 3000)
    })
}